var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.707 9.29297L12.707 4.29297C12.6142 4.20013 12.5039 4.12648 12.3826 4.07623C12.2613 4.02598 12.1313 4.00012 12 4.00012C11.7348 4.00012 11.4805 4.10546 11.293 4.29297C11.2002 4.38582 11.1265 4.49604 11.0763 4.61735C11.026 4.73865 11.0002 4.86867 11.0002 4.99997C11.0002 5.26515 11.1055 5.51946 11.293 5.70697L14.586 8.99997H3C2.73478 8.99997 2.48043 9.10533 2.29289 9.29286C2.10536 9.4804 2 9.73476 2 9.99997C2 10.2652 2.10536 10.5195 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H14.586L11.293 14.293C11.1055 14.4805 11.0002 14.7348 11.0002 15C11.0002 15.2651 11.1055 15.5195 11.293 15.707C11.4805 15.8945 11.7348 15.9998 12 15.9998C12.2652 15.9998 12.5195 15.8945 12.707 15.707L17.707 10.707C17.7999 10.6142 17.8737 10.504 17.924 10.3827C17.9743 10.2614 18.0002 10.1313 18.0002 9.99997C18.0002 9.86864 17.9743 9.73859 17.924 9.61728C17.8737 9.49596 17.7999 9.38576 17.707 9.29297Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.1bf50098ea8bf85194ca8ac8f2805424.svg";
export { ForwardRef as ReactComponent };